<template>
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row align-items-center">
            <template>
  
              <bita-select
                ref="vehicleTypes"
                label="نوع ماشین"
                rules=""
                validation-container-class="col-3 mt-4"
                input-class="form-control"
                :data-source="vehicleTypes"
                data-text-field="name"
                data-value-field="id"
                v-model="formData.vehicleType_id"
              />
  
              <div class="col-3 align-items-center">
                <bita-input
                  type="text"
                  label=" ظرفیت هر وسیله نقلیه چند پالت ؟ "
                  rules=""
                  input-class="form-control"
                  v-model.lazy="formData.count"
                />
              </div>
  
              <div class="col-3 mt-3 align-items-center">
                <bita-bootbutton
                    title="افزودن نوع ماشین"
                    type="primary"
                    icon="fas fa-plus-square"
                    btn-width="200px"
                    @click.native="addVehicleTypeToProduct"
                  />
              </div>
  
            </template>
          </div>
        </div>
      </bita-form>
  
      <table class="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col"> نوع ماشین </th>
            <th scope="col">ظرفیت هر وسیله</th>
            <th scope="col"> عملیات </th>
          </tr>
        </thead>
        <tbody>
          <tr colspan="4" v-if="isLoading">
            <td class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </td>
          </tr>
          <tr v-else v-for=" ( item, index ) in cargos " :key="index">
            <th scope="row">{{ index+1 }}</th>
            <td>{{ item.vehicle_type_name }}</td>
            <td> {{ item.count }} پالت </td>
            <td>
              <button type="button" class="btn btn-danger" @click="deleteCargo(item.id,index+1)">حذف</button>
            </td>
          </tr>
        </tbody>
      </table>
  
    </div>
</template>
<script>
import { vehicleTypeApi, cargoApi } from "@/api/apiManagement";
export default {
  props: {
    title: String,
    // isLoading: Boolean,
  },
  data() {
    return {
      form: {},
      formData: {},
      vehicleTypes: [],
      cargos: [],
      currentPage: 1,
      pageSize: 30,
      isLoading: false,
      product: {},
    };
  },
  computed: {
    formRef() {
      return this.$refs.form;
    },
  },
  methods: {
    deleteCargo(cargoId,row) {
      this.$alert("question", `آیا از حذف ردیف ${row} اطمینان دارید؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          cargoApi
            .delete(cargoId)
            .then((res) => {
              this.$izitoast("success", "با موفقیت حذف شد", "موفق");
              this.getCargos(this.product.id)
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },
    setInitialValue(_data) {
      this.product = _data;
      this.getVehicleTypes();
      this.getCargos(_data.id)
    },
    getCargos(productId) {
      this.isLoading = true;
      cargoApi
        .get({
          page_size: this.pageSize,
          page: this.currentPage,
          productId
        })
        .then((res) => {
          this.cargos = res.data.entity.data;
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    getVehicleTypes() {
      vehicleTypeApi.get()
        .then((res) => [(
            this.vehicleTypes = res.data.entity
          )]);
    },
    addVehicleTypeToProduct() {
      this.isLoading = true
      this.formData.product_id = this.product.id;
      cargoApi
        .create(this.formData)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);
          this.getCargos(this.product.id)
        })
        .catch((err) => {  })
        .finally(() => {
          this.isLoading = false;
          this.formRef.reset();
        });
    },
    save() {
      return new Promise((resolve, reject) => {
        resolve(true);
      });
    },
    setErrors(err) {
      this.$refs.form.setErrors(err);
    },  
    reset() {
      this.form = {};
      this.formData = {};
      this.formRef.reset();
    },
  },
};
</script>

<style scoped>
    ul.dropdown-list {
        border: 1px solid #ccc;
        border-radius: 0 0 5px 5px;
        padding: 0;
        position: absolute;
        width: 87%;
        background: #fff;
    }
    li {
        list-style: none;
        padding: 5px 12px;
    }
    li a {
        color: #585858;
    }
    li:hover {
        background: #adadad;
    }
</style>